export default {
  stopProcesses: (state) => state.stopProcesses,
}
